var app = new function(){
	this.modules = {};
	this.settings = {};
	this.vars = {
		screenMobile:true,
		screenMobileLandscape:false,
		screenTablet:false,
		screenTabletLandscape:false,
		screenDesktop:false,
		screenWide:false,
		screenFull:false,
		breakPoint:'mobile',
		isTouchDevice:false,
		ieVersion:false
	};
	this.init = function(){
		var that = this;

		// extend jquery
		jQuery.extend({
			getQueryParameters:function(str){
				return (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this}.bind({}))[0];
			}
		});
		
		this.setBreakPoint();
		this.resize();
		this.detectTouchDevice();
		var context = this;
		that.vars.ieVersion = that.msieversion();
		$.each(this.modules, function(index, element){
			if (typeof element.init === 'function'){
				element.init();
			}
		});
		this.parse($('body'));
		$(window).bind('load', function(){
			$.each(that.modules, function(index, element){
				if (typeof element.onLoad === 'function'){
					element.onLoad();
				}
			});
		});
	};
	this.parse = function($context){
		$.each(this.modules, function(index, element){
			if (typeof element.parse === 'function'){
				element.parse($context);
			}
		});
	};
	this.resize = function($context){
		var that = this;
		$(window).resize(function(){
			if (that.vars.isTouchDevice == false){
				that.setBreakPoint();
			}
		});
		$(window).on('orientationchange', function(event){
			that.setBreakPoint();
		});
		$.each(this.modules, function(index, element){
			if (typeof element.resize === 'function'){
				$(window).resize(function(){
					if (that.vars.isTouchDevice == false){
						element.resize();
					}
				});
				$(window).on('orientationchange', function(event){
					element.resize(event.orientation);
				});
			}
		});
		$(window).trigger('resize');
	};
	this.detectTouchDevice = function(){
		if (Modernizr.touch){
			app.vars.isTouchDevice = true;
		}
	};
	this.getViewport = function(type){
		var viewPortWidth;
		var viewPortHeight;
		if (typeof window.innerWidth != 'undefined'){
			viewPortWidth = window.innerWidth,
			viewPortHeight = window.innerHeight
		} else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
			viewPortWidth = document.documentElement.clientWidth,
			viewPortHeight = document.documentElement.clientHeight
		} else {
			viewPortWidth = document.getElementsByTagName('body')[0].clientWidth,
			viewPortHeight = document.getElementsByTagName('body')[0].clientHeight
		}
		if (type == 'width'){
			return viewPortWidth;
		} else {
			return viewPortHeight;
		}
	};
	this.reinit = function($context){
		$.each(this.modules, function(index, element){
			if (typeof element.reinit === 'function'){
				element.reinit();
			}
		});
	};
	this.setBreakPoint = function(){
		var that = this;
		var windowWidth = that.getViewport('width');
		var breakPoint = 'mobile';
		app.vars.screenMobileLandscape = false;
		app.vars.screenTablet = false;
		app.vars.screenTabletLandscape = false;
		app.vars.screenDesktop = false;
		app.vars.screenWide = false;
		app.vars.screenFull = false;
		if (windowWidth >= 480){
			breakPoint = 'mobileLandscape';
			app.vars.screenMobileLandscape = true;
		}
		if (windowWidth >= 768){
			breakPoint = 'tablet';
			app.vars.screenTablet = true;
		}
		if (windowWidth >= 1024){
			breakPoint = 'tabletLandscape';
			app.vars.screenTabletLandscape = true;
		}
		if (windowWidth >= 1224){
			breakPoint = 'desktop';
			app.vars.screenDesktop = true;
		}
		if (windowWidth >= 1324){
			breakPoint = 'wide';app.vars.screenWide = true;
		}
		if (windowWidth >= 1600){
			breakPoint = 'full';
			app.vars.screenFull = true;
		}
		if (breakPoint != that.vars.breakPoint){
			that.vars.breakPoint = breakPoint;
		}
	};
	this.msieversion = function(){
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
			return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
		} else {
			return false;
		}
	};
	this.fixedContent = function(type){
		var htmlBody = $('html,body');
		var currentScrollTop = $(window).scrollTop();
		if (type == true && !htmlBody.hasClass('fixed')){
			htmlBody.addClass('fixed');
			$('.site').css({
				marginTop:currentScrollTop*-1
			});
			htmlBody.scrollTop(0);
		} else {
			var newScrollTop = parseInt($('.site').css('margin-top'));
			$('.site').attr('style','');
			htmlBody.removeClass('fixed');
			htmlBody.scrollTop(newScrollTop*-1);
		}
	};
};
$(function(){
	if (typeof $('.onepager-tile').html() !== 'undefined'){
		app.modules.onepager.init();
	} else {
		app.init();
	}
});
function _history(){
	this.historyLog = [];
	this.historyContent = [];
	this.vars = {
		historyLogIndex:-1,
		contentChanged:false,
		allowStateChange:false,
		module:null,
		userClicked:true,
		startUrl:this.relativeUrl(window.location.href),
		lastState:0,
		stateChanged:false
	}
}
_history.prototype = {
	init:function(){
		this.addListener();
		this.historyContent[this.relativeUrl(document.location.href)] = document.documentElement.outerHTML;
	},
	addListener:function(){
		var that = this;
		window.onpopstate = function(event){
			if (typeof event.isTrigger == 'undefined' && event.state !== null){
				that.loadPage(document.location.href, 'body', null, null);
			}
		};
	},
	loadPage:function(tile, selector, moduleName, moduleFunction){
		if (tile instanceof jQuery){
			var url = tile.attr('href');
		} else {
			var url = tile;
		}
		if (this.allowStateChange(url) === false && moduleName !== null){
			return false;
		}
		if (!window.History.enabled){
			document.location.href = url;
			return false;
		}
		var that = this;
		$.ajax({
			type:'GET',
			url:url,
			data:'',
			success:function(data){
				var $data = $('<i/>' + that.documentHtml(data));
				var $dataBody = $data.find('.document-body:first');
				var $dataTitle = $data.find('title').html();
				var $dataContent = selector == 'body' ? $dataBody.filter(':first') : $dataBody.find(selector).filter(':first');
				var contentHtml = $dataContent.html()||$data.html();
				if (!contentHtml){
					document.location.href = url;
					return false;
				}
				that.vars.module = moduleName;
				that.updateTitle(that.documentTitle(data));
				that.vars.contentChanged = true;
				if (that.vars.historyLogIndex < 0){
					var logStart = {url:that.vars.startUrl, module:moduleName, moduleFunction:moduleFunction, scrollTop:$(window).scrollTop()};
					that.historyLog.push(logStart);
					that.historyContent[that.relativeUrl(url)] = data;
					that.vars.historyLogIndex = 0;
				}
				var log = {url:url, module:moduleName, moduleFunction:moduleFunction, scrollTop:$(window).scrollTop()};
				that.historyLog.push(log);
				that.historyContent[that.relativeUrl(url)] = data;
				that.vars.historyLogIndex++;
				that.pushState(url, that.documentTitle(data));
				that.vars.contentChanged = false;
				if (moduleName !== null){
					app.modules[moduleName].pageLoaded(contentHtml);
				} else {
					that.pageLoaded(selector, contentHtml);
				}
				that.tracking(url);
			},
			error:function(jqXHR, textStatus, errorThrown){
				document.location.href = url;
				return false;
			}
		});
	},
	simulateStateChange:function(tile, moduleName, moduleFunction, title){
		if (tile instanceof jQuery){
			var url = tile.attr('href');
		} else {
			var url = tile;
		}
		if (!window.History.enabled) {
			document.location.href = url;
			return false;
		}
		var that = this;
		that.vars.module = moduleName;
		that.updateTitle(title);
		that.vars.contentChanged = true;
		var log = {url:url, module:moduleName, moduleFunction:moduleFunction, scrollTop:$(window).scrollTop()};
		that.historyLog.push(log);
		that.historyContent[that.relativeUrl(url)] = document.documentElement.outerHTML;
		that.vars.historyLogIndex++;
		that.pushState(url, title);
		that.vars.contentChanged = false;
		if (moduleName !== null){
			app.modules[moduleName].pageLoaded(null);
		}
		that.tracking(url);
	},
	pageLoaded:function(selector, contentHtml){
		$(selector).html(contentHtml);
		$.each(app.modules, function(index, element){
			$.each(element, function(indexSub, elementSub){
				if (elementSub instanceof jQuery){
					app.modules[index][indexSub] = $(elementSub.selector);
				}
			});
		});
		app.reinit();
		app.fixedContent(false);
	},
	documentHtml:function(html){
		var result = String(html).replace(/<\!DOCTYPE[^>]*>/i, '').replace(/<(html|head|body|title|meta|script)([\s\>])/gi,'<div class="document-$1"$2').replace(/<\/(html|head|body|title|meta|script)\>/gi,'</div>');
		return result;
	},
	documentTitle:function(html){
		var html = html.match(/<title[^>]*>([^<]+)<\/title>/);
		if (html === null){
			return '';
		} else {
			return html[1];
		}
	},
	pushState:function(url, title){
		var that = this;
		if (that.vars.stateChanged !== true){
			window.History.pushState(null, title, url);
			that.vars.stateChanged = false;
		}
		return false;
	},
	tracking:function(path){
		if (typeof ga !== 'undefined'){
			ga('set', {page:this.relativeUrl(path), title:document.title.replace('<','&lt;').replace('>','&gt;').replace(' & ',' &amp; ')});
			ga('send', 'pageview');
		}
	},
	relativeUrl:function(url){
		var	root = location.protocol+'//'+location.host,
			relativeUrl = url.replace(root, '').replace('./', '/');
		
		if (relativeUrl.charAt(0) != '/'){
			relativeUrl = '/'+relativeUrl;
		}
		return relativeUrl;
	},
	allowStateChange:function(url){
		var that = this;
		if (that.vars.userClicked == true){
			that.vars.userClicked = false;
			return true;
		}
		if (this.relativeUrl(url) != this.relativeUrl(window.location.href) || this.vars.allowStateChange == true){
			that.vars.allowStateChange = false;
			return true;
		} else {
			return false;
		}
	},
	updateTitle:function(text){
		document.title = text;
		try { document.getElementsByTagName('title')[0].innerHTML = document.title.replace('<','&lt;').replace('>','&gt;').replace(' & ',' &amp; '); }
		catch (Exception) { }
	}
};
app.modules._history = new _history;
function onepager(){
	this.vars = {
		sectionCount:0,
		sections:[],
		loadedPages:0,
		loadedPercentage:0,
		loadingComplete:false,
		loaded:false
	}
}
onepager.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		// check for onepager sections
		if (typeof $('.onepager-tile').html() !== 'undefined' && that.vars.loaded == false){
			that.vars.loaded = true;
			var allSections = $('.onepager-tile');
			var sectionsOnepager = $('.onepager-tile[data-loaded="false"]');
			that.vars.sectionCount = sectionsOnepager.size();
			allSections.each(function(index){
				$('a[href="'+$(this).attr('data-url')+'"]').addClass('onepager-link');
			});
			sectionsOnepager.each(function(index){
				var section = $(this);
				var sectionUrl = section.attr('data-url')
				that.vars.sections.push(section);
				that.loadPage(sectionUrl, index);
			});
		}
	},
	addListener:function(){
		var that = this;

		// click onepager navi
		$('.onepager-link').unbind().on({
			click:function(){
				that.goToSection($(this));
				return false;
			}
		});
	},
	loadPage:function(url, index){
		var that = this;
		$.ajax({
			type:'GET',
			url:url,
			data:'',
			success:function(data){
				var $data = $('<i/>' + app.modules._history.documentHtml(data));
				var $dataBody = $data.find('.document-body:first');
				var $dataContent = $dataBody.find('.onepager-tile[data-loaded="true"]');
				var contentHtml = $dataContent.html()||$data.html();
				if (contentHtml){
					var contentHtmlObj = $('<div>'+contentHtml+'</div>');
					contentHtmlObj.find('header, footer').remove();
					contentHtml = contentHtmlObj.html();
					$('.onepager-tile[data-url="'+url+'"]').html(contentHtml);
					$dataContent.waitForImages({
						finished:function(){
							var newPercentageLoaded = Math.floor((100*that.vars.loadedPages)/that.vars.sectionCount);
							if (newPercentageLoaded > that.vars.loadedPercentage){
								that.vars.loadedPercentage = newPercentageLoaded;
							}
							that.loader(that.vars.loadedPercentage);
							that.vars.loadedPages++;
							if (that.vars.sectionCount == that.vars.loadedPages){
								that.finish();
							}
						},
						each:function(loaded, count, success){
							var currentPercentageLoaded = (100*that.vars.loadedPages)/that.vars.sectionCount;
							var division = Math.floor(100/that.vars.sectionCount);
							var sectionLoaded = Math.floor((division*loaded)/count);
							var newPercentageLoaded = Math.floor(currentPercentageLoaded+sectionLoaded);
							if (newPercentageLoaded > that.vars.loadedPercentage){
								that.vars.loadedPercentage = newPercentageLoaded;
							}
							that.loader(that.vars.loadedPercentage);
						},
						waitForAll:true
					});
				}
			}
		});
	},
	goToSection:function(link){
		var that = this;
		var section = $('.onepager-tile[data-url="'+link.attr('href')+'"]');
		if (app.modules._history.allowStateChange(link.attr('href'))){
			app.modules._history.simulateStateChange(link, null, null, section.attr('data-title'));
		}
		setTimeout(function(){
			$('.onepager-link').removeClass('active');
			$('.onepager-link[href="'+(link.attr('href'))+'"]').addClass('active');
			$('html,body').animate({
				scrollTop:section.offset().top-$('.module--navigation').outerHeight()
			}, 800, 'easeOutCubic', function(){
				//
			});
		}, 100);
	},
	reinit:function(){
		this.addListener();
	},
	finish:function(){
		var that = this;
		$('header').prependTo('.site__inner');
		$('footer').appendTo('.site__inner');
		setTimeout(function(){
			var curSectionOffsetTop = $('.onepager-tile[data-loaded="true"]').offset().top-$('.module--navigation').outerHeight();
			$('html,body').scrollTop(curSectionOffsetTop);
			if (curSectionOffsetTop > 0){
				setTimeout(function(){
					var naviNode = document.querySelector('.module--navigation');
					var naviTransform = new WebKitCSSMatrix(window.getComputedStyle(naviNode).webkitTransform);
					$('html,body').scrollTop(curSectionOffsetTop-naviTransform.m42);
				}, 400);
			}
			if ($.trim(window.location.hash) != '' && typeof $('.anchor[name="'+window.location.hash.replace('#', '')+'"]').attr('name') !== 'undefined'){
				var anchorObj = $('.anchor[name="'+window.location.hash.replace('#', '')+'"]');
				setTimeout(function(){
					$('html,body').scrollTop(anchorObj.offset().top);
				}, 410);
			}
			$('.module').removeClass('module--odd module--even').each(function(index){
				var module = $(this);
				if ((index+1) %2 == 0){
					module.addClass('module--even');
				} else {
					module.addClass('module--odd');
				}
			});
			that.vars.loadingComplete = true;
			that.loader(100);
		}, 100);
		$.each(app.modules, function(index, element){
			$.each(element, function(indexSub, elementSub){
				if (elementSub instanceof jQuery){
					app.modules[index][indexSub] = $(elementSub.selector);
				}
			});
		});
		app.init();
	},
	loader:function(percentage){
		var that = this;
		console.log(percentage);
	}
};
app.modules.onepager = new onepager;
function navigation(){
	this.htmlBody = $('html,body');
	this.navigation = $('.module--navigation');
	this.burger = $('.navigation__burger');
}
navigation.prototype = {
	init:function(){
		var that = this;
		that.addListener();
	},
	addListener:function(){
		var that = this;
		that.burger.unbind().on({
			click:function(){
				that.toggleMobileMenu();
			}
		});
		$(window).on({
			click:function(){
				if (that.burger.hasClass('selected')){
					that.toggleMobileMenu();
				}
			}
		});
		that.navigation.find('nav ul li a').on({
			click:function(){
				if (that.burger.hasClass('selected')){
					that.toggleMobileMenu();
				} else {
					//
				}
			}
		});
		that.navigation.find('nav ul, .navigation__burger').click(function(e){
			e.stopPropagation();
		});
	},
	toggleMobileMenu:function(){
		var that = this;
		if (!that.burger.hasClass('selected')){
			that.burger.addClass('selected');
			that.navigation.find('nav ul').addClass('show');
			that.htmlBody.addClass('opennav');
			app.fixedContent(true);
		} else {
			that.burger.removeClass('selected');
			that.navigation.find('nav ul').removeClass('show');
			that.htmlBody.removeClass('opennav');
			app.fixedContent(false);
		}
	},
	reinit:function(){
		this.addListener();
	}
};
app.modules.navigation = new navigation;
function header(){
	this.header = $('.module--header');
	this.navigation = $('.module--navigation');
}
header.prototype = {
	init:function(){
		var that = this;
		that.addListener();
		that.resize();
	},
	addListener:function(){
		var that = this;

		// scroll down
		$('.header__down').unbind().on({
			click:function(){
				var newScrollPos = that.header.outerHeight();
				$('html,body').animate({
					scrollTop:newScrollPos
				}, 800, 'easeOutCubic', function(){
					//
				});
				return false;
			}
		});
	},
	resize:function(){
		var that = this;

		// resize fullscreen header
		if (typeof that.header.html() !== 'undefined' && that.header.hasClass('module--header-full')){
			var headerHeight = app.getViewport('height');
			if (app.vars.screenDesktop === true){
				headerHeight = headerHeight-100;
			} else {
				headerHeight = headerHeight-35;
			}
			if (typeof that.navigation.html() !== 'undefined'){
				headerHeight = headerHeight-that.navigation.outerHeight();
			}
			that.header.css({
				height:headerHeight
			});
		}
	}

};
app.modules.header = new header;
function form(){
	this.vars = {
		loading:false,
		dependencyFieldStr:'input[data-dependencies],select[data-dependencies],option[data-dependencies],textarea[data-dependencies]'
	}
}
form.prototype = {
	init:function(){
		var that = this;
		that.addListener();
		that.replaceJcf();
		that.maskInput();
		that.formValidation();

		// check for dependencies
		$('select').trigger('change');
	},
	addListener:function(){
		var that = this;

		// select dependencies
		$('select').unbind().on({
			change:function(){
				that.checkForDependencies($(this));
			}
		});
	},
	replaceJcf:function(){
		jcf.setOptions('Select', {
			wrapNative:false,
			wrapNativeOnMobile:false,
			fakeDropInBody:false
		});
		jcf.replaceAll();
	},
	reinit:function(){
		var that = this;
		that.replaceJcf();
		that.maskInput();
		that.formValidation();
	},
	formValidation:function(){
		var that = this;

		// global ajax form submit
		$('form.form--validate').each(function(){
			var formObj = $(this);
			var moduleKey = formObj.find('input[name="moduleKey"]').val();
			var postId = formObj.find('input[name="postId"]').val();
			formObj.validate({
				normalizer: function( value ) {
					return $.trim( value );
				},				
				rules: window['rules_'+moduleKey+'_'+postId],
				messages: window['messages_'+moduleKey+'_'+postId],
				invalidHandler:function(event, validator){
					if (typeof formObj.find('.form__row--messages').html() !== 'undefined'){
						var messageContainer = formObj.find('.form__row--messages');
						messageContainer.removeClass('hidden').addClass('form__row--error').html(window['message_error_'+moduleKey+'_'+postId]+'<ul></ul>');
						$.each(validator.invalid, function(index, obj){
							messageContainer.find('ul').append('<li>'+validator.invalid[index]+'</li>');
						});
					}

					window.scroll({
						top: ($("#form-" + moduleKey).position().top - $(".module--navigation").height() - 40),
						behavior: 'smooth'
					});
				},
				submitHandler:function(form){
					if (that.vars.loading == false){
						that.vars.loading = true;
						if (typeof formObj.attr('data-ajax-post') !== 'undefined' && formObj.attr('data-ajax-post') == 'true'){
							that.ajaxSubmit(formObj);
						} else {
							form.submit();
						}
					}
				}
			});
		});
	},
	ajaxSubmit:function(form){
		var that = this;
		that.form = form;
		var moduleKey = form.find('input[name="moduleKey"]').val();
		var postId = form.find('input[name="postId"]').val();
		form.addClass('form--loading');
		$.ajax({
			type:'POST',
			url:form.attr('action'),
			data:form.serialize(),
			error:function(jqXHR, exception){
				if (typeof form.find('.form__row--messages').html() !== 'undefined'){
					var messageContainer = form.find('.form__row--messages');
					messageContainer.removeClass('hidden').addClass('form__row--error').empty().html(window['message_error_'+moduleKey+'_'+postId]+'<ul></ul>');
					$.each(jqXHR.responseJSON, function(index, obj){
						messageContainer.find('ul').append('<li>'+obj[0]+'</li>');
					});
				}
				that.vars.loading = false;
				form.removeClass('form--loading');
			},
			success:function(data, textStatus, xhr){
				if (data.success == 'false'){
					if (typeof form.find('.form__row--messages').html() !== 'undefined'){
						var messageContainer = form.find('.form__row--messages');
						messageContainer.removeClass('hidden').addClass('form__row--error').empty().html(window['message_error_'+moduleKey+'_'+postId]+'<ul></ul>');
						$.each(data.error, function(index, obj){
							messageContainer.find('ul').append('<li>'+obj.message+'</li>');
						});
					}
				} else {
					if (typeof form.find('[name="callbackModule"]').val() !== 'undefined' && form.find('[name="callbackModule"]').val() != '' && typeof form.find('[name="callbackFunction"]').val() !== 'undefined' && form.find('[name="callbackFunction"]').val() != ''){
						form.find('.form__row--messages').removeClass('form__row--error').addClass('hidden').empty();
						var callbackModule = form.find('[name="callbackModule"]').val();
						var callbackFunction = form.find('[name="callbackFunction"]').val();
						app.modules[callbackModule][callbackFunction](form, data);
					} else {
						form.find('.form__row--messages').removeClass('form__row--error hidden').addClass('form__row--success').empty().html(window['message_success_'+moduleKey+'_'+postId]);
						form.find('*').not('.form__row--success, .form__row--success *').remove();
					}
				}
				that.vars.loading = false;
				form.removeClass('form--loading');
			}
		});
	},
	checkForDependencies:function(field){
		var that = this;
		fieldValue = field.val();
		fieldName = field.attr('name');
		currentForm = field.closest('form');
		var dependencyFields = currentForm.find(that.vars.dependencyFieldStr);
		dependencyFields.each(function(){
			var dependencyField = $(this);
			var dataDependency = dependencyField.attr('data-dependencies');
			if ($.trim(dataDependency) != ''){
				var dataDependencyArr = dataDependency.split(';');
				var evalStr = 'if (';
				$.each(dataDependencyArr, function(key, value){
					var operator = '==';
					var dependencyRuleArr = value.split('=');
					var dependencyFieldName = dependencyRuleArr[0];
					var dependencyFieldNameLastChar = dependencyFieldName.substr(dependencyFieldName.length-1);
					if (dependencyFieldNameLastChar == '!'){
						dependencyFieldName = dependencyFieldName.slice(0,-1);
						var operator = '!=';
					}
					var dependencyFieldValue = dependencyRuleArr[1];
					if (value == 'AND'){
						evalStr += " && ";
					} else if (value == 'OR'){
						evalStr += " || ";
					} else {
						evalStr += "$.trim(currentForm.find('[name=\""+dependencyFieldName+"\"]').val())"+operator+"'"+dependencyFieldValue+"'";
					}
				});
				evalStr += "){that.showField(dependencyField);}else{that.hideField(dependencyField);}";
				eval(evalStr);
			}
		});
	},
	showField:function(field){
		var that = this;
		var parentRow = field.closest('.form__row');
		var parentCol = field.closest('[class^="col-"]');
		if (field.is('option')){
			field.removeClass('hidden');
		} else {
			parentRow.removeClass('hidden');
			parentCol.removeClass('hidden');
		}
	},
	hideField:function(field){
		var that = this;
		var parentRow = field.closest('.form__row');
		var parentCol = field.closest('[class^="col-"]');
		if (field.is('option')){
			field.addClass('hidden');
		} else {
			// reset value
			if (field.is('select')){
				field.prop('selectedIndex', 0);
				that.replaceJcf();
			} else if (field.is(':checkbox')){
				field.attr('checked', false);
				that.replaceJcf();
			} else {
				field.val('');
			}

			if (parentRow.find('input,select,textarea').size() == 1){
				parentRow.addClass('hidden');
			} else {
				parentCol.addClass('hidden');
				if (parentRow.find('[class^="col-"]').size() > 1){
					if (parentRow.find('[class^="col-"]').size() == parentRow.find('[class^="col-"].hidden').size()){
						parentRow.addClass('hidden');
					}
				}
			}
		}
	},
	maskInput:function(){
		var maskInputFields = $('[data-mask]');
		maskInputFields.each(function(){
			var maskInputField = $(this);
			maskInputField.mask(maskInputField.attr('data-mask'));
		});
	},
	reinit:function(){
		this.init();
	}
};
app.modules.form = new form;
function overlay(){
	this.vars = {
		overlayGetValues:''
	}
}
overlay.prototype = {
	init:function(){
		this.addListener();
		if (typeof $('.overlay').html() !== 'undefined' && !$('.overlay').hasClass('overlay--keep')){
			app.fixedContent(true, false);
		}
	},
	addListener:function(){
		var that = this;
		$('[data-open-overlay], [href^="#overlay-"]').unbind().on({
			click:function(){
				that.openOverlay($(this));
				return false;
			}
		});
		$('.overlay').find('.close').unbind().on({
			click:function(){
				that.closeOverlay();
				return false;
			}
		});
		$('body').unbind().on({
			click:function(e){
				var target = $(e.target);
				if (!target.hasClass('dz-hidden-input')){
					that.closeOverlay();
				}
			}
		});
		$('.button--close-overlay').unbind().on({
			click:function(){
				that.closeOverlay();
				return false;
			}
		});
		$('.overlay__content_inner').unbind().on({
			click:function(e){
				e.stopPropagation();
			}
		});
		$(document).unbind().keyup(function(e){
			if (e.keyCode == 27){
				that.closeOverlay();
			}
		});
	},
	openOverlay:function(link){
		var that = this;
		if (link instanceof jQuery){
			var url = link.attr('href');
			var overlayId = link.attr('data-overlay');
			that.vars.overlayGetValues = encodeURIComponent(link.attr('data-get'));
		} else {
			var url = '#'+link;
		}
		app.fixedContent(true, true);
		if (typeof overlayId !== 'undefined' && typeof $(overlayId.replace(/[/.]/g, '')).html() !== 'undefined'){
			that.buildOverlay(null, overlayId);
		} else if (typeof $(url.replace(/[/.?&=]/g, '')).html() !== 'undefined'){
			that.buildOverlay($(url).html());
		} else {
			url = url.replace('#/', '/');
			that.buildOverlay('');
			$.ajax({
				type:'GET',
				url:url,
				data:'',
				success:function(data){
					$(data).waitForImages({
						finished:function(){
							that.buildOverlay(data);
						},
						each:function(loaded, count, success){
							//
						},
						waitForAll:true
					});
				}
			});
		}
	},
	closeOverlay:function(){
		var that = this;
		$('.overlay').each(function(){
			var overlay = $(this);
			overlay.find('.overlay__inner').removeClass('overlay__inner--show');
			overlay.removeClass('overlay--show');
			that.vars.overlayGetValues = '';
			setTimeout(function(){
				if (!overlay.hasClass('overlay--keep')){
					overlay.remove();
				}
				if (overlay.hasClass('overlay--keep')){
					overlay.addClass('hidden');
				}
				app.fixedContent(false, false);

				// dropzone
				app.modules.form.vars.dropzoneInitialized = false;
				$('.dz-hidden-input').remove();
			}, 310);
		});
	},
	buildOverlay:function(data, selector){
		var that = this;
		if (data == null){
			var overlay = $(selector);
			overlay.removeClass('hidden');
		} else {
			if (typeof that.vars.overlayGetValues !== 'undefined' && that.vars.overlayGetValues != ''){
				var getArr = that.vars.overlayGetValues.split('&');
				var getArrKeys = []
				var getArrValues = [];
				for(var i = 0; i < getArr.length; i++){
					var getItemArr = getArr[i].split('=');
					if (getItemArr.length == 1){
						getItemArr = getArr[i].split('%3D');
					}
					getArrKeys.push(getItemArr[0]);
					getArrValues.push(getItemArr[1]);
				}
				for(var ii = 0; ii < getArrKeys.length; ii++) {
					data = data.replace(new RegExp('{' + getArrKeys[ii] + '}', 'gi'), getArrValues[ii]);
				}
			}
			if (typeof $('.overlay').html() == 'undefined' || $('.overlay').hasClass('overlay--keep')){
				$('body').append('<div class="overlay">'+data+'</div>');
			} else {
				$('.overlay').html(data);
			}
			var overlay = $('.overlay:not(.overlay--keep)');
		}
		setTimeout(function(){
			overlay.addClass('overlay--show');
			overlay.find('.overlay__inner').addClass('overlay__inner--show');
			that.addListener();
			app.reinit();
		}, 110);
	}
};
app.modules.overlay = new overlay;
function footer(){
	this.footer = $('.module--footer');
	this.site = $('.site__inner');
}
footer.prototype = {
	init:function(){
		var that = this;
		that.addListener();
		that.resize();
	},
	addListener:function(){
		var that = this;

		$(window).scroll(function(){
			that.resize();
		});
	},
	resize:function(){
		var that = this;
		var viewportHeight = app.getViewport('height');
		var pageHeight = that.site.outerHeight();
		if (pageHeight >= viewportHeight-that.footer.outerHeight()){
			that.footer.addClass('module--footer-static');
		} else {
			that.footer.removeClass('module--footer-static');
		}
	},
	reinit:function(){
		this.resize();
	}
};
app.modules.footer = new footer;
function anchor(){
	this.navigation = $('.module--navigation');
}
anchor.prototype = {
	init:function(){
		var that = this;
		that.addListener();

		if ($.trim(window.location.hash) != ''){
			$(window).load(function(){
				setTimeout(function(){
					var hash = $.trim(window.location.hash);
					var target = $('a[id="'+hash.replace('#', '')+'"]');
					var newScrollTopPos = target.offset().top;
					if (typeof that.navigation.html() !== 'undefined'){
						newScrollTopPos = newScrollTopPos-that.navigation.outerHeight();
					}
					$('html,body').scrollTop(newScrollTopPos);
				}, 100);
			});
		}
	},
	addListener:function(){
		var that = this;

		$('a[href*=#]').on({
			click:function(e){
				e.preventDefault();
				var link = $(this);
				var target = $('a[id="'+link.attr('href').replace('#', '')+'"]');
				var newScrollTopPos = target.offset().top;
				if (typeof that.navigation.html() !== 'undefined'){
					newScrollTopPos = newScrollTopPos-that.navigation.outerHeight();
				}
				$('html,body').animate({
					scrollTop:newScrollTopPos
				}, 800, 'easeInOutExpo', function(){
					window.location.hash = link.attr('href');
				});
			}
		});
	}
};
app.modules.anchor = new anchor;